import { IDELayout } from '@common/ide/Layout';
import ProjectsList from '@common/ide/ProjectsList';
import { toIDEEntity } from '@common/ide/utils';
import { ProjectSearchInput } from '@common/SearchInput';
import { Entity } from '@common/types/Entity';
import { Private_Routes } from '@common/url';
import { ArrowRightIcon } from '@prophecy/icons';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { theme } from '@prophecy/theme';
import { Centered, Stack, StackItem, Text } from '@prophecy/ui-v3';
import DocumentTitle from '@prophecy/utils/react/DocumentTitle';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { NewObservationHome } from '../Observation/NewObservationHome';

const ContentArea = styled(Centered)`
  background: ${theme.colors.gray25};
`;

const StyledCircle = styled(Stack)`
  width: ${theme.sizes.x40};
  height: ${theme.sizes.x40};
  border-radius: 50%;
  border: 1px solid ${theme.colors.gray300};
`;

const StyledStack = styled(Stack)`
  height: 100%;
`;

const StyledStackItem = styled.div`
  border-right: 1px solid ${theme.colors.gray200};
`;

function IDEProjectView({ entity }: { entity?: Entity }) {
  const isObservation = entity === Entity.Observation;
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <DocumentTitle title={isObservation ? 'Observations' : `IDE Home`} />
      {isObservation ? (
        <NewObservationHome />
      ) : (
        <IDELayout
          leftSlot={
            <StyledStack>
              <StyledStackItem>
                <ProjectSearchInput
                  value={searchQuery}
                  onChange={setSearchQuery}
                  data-test-id='ide-home-project-search-input'
                />
              </StyledStackItem>
              <StackItem grow='1'>
                <ProjectsList searchQuery={searchQuery} entity={entity} />
              </StackItem>
            </StyledStack>
          }
          rightSlot={
            <ContentArea>
              <Stack direction='horizontal' alignY='center' gap={theme.spaces.x12}>
                <StyledCircle alignY='center' align='center'>
                  <ArrowRightIcon type='default' color={theme.colors.gray300} size='l' />
                </StyledCircle>
                <Text level='lg' weight={theme.fontWeight.medium} tone={theme.colors.gray400}>
                  Choose a project to start development
                </Text>
              </Stack>
            </ContentArea>
          }></IDELayout>
      )}
    </>
  );
}

export default function IdeHome() {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.IDE_Home.url>>();
  const _entity = toIDEEntity(params.entity as string);

  return <IDEProjectView entity={_entity} />;
}
